import { AddDefaultUnit } from '@inntechcorp/it-design';
import styled, { css } from 'styled-components';

/* --------------- SUB PAGE HEADER ------------------ */

const SubPageHeader = styled.div<{
  $isFormType? : boolean
}>`
  
  font-size       : ${props => props.$isFormType ? "12px" : "14px"};
  color           : ${props => props.$isFormType ? "#cccccccc" : "#cccccc"};
  font-weight     : 600;

  >div span { 
    font-size       : ${props => props.$isFormType ? "12px" : "14px"};
    color           : ${props => props.$isFormType ? "#cccccccc" : "#cccccc"};
    font-weight     : 600;
  }

  .itd-button-link span {
    font-weight     : 600;
  }

  display           : flex;
  flex-direction    : row;
  justify-content   : space-between;
  align-items       : center;

  margin-bottom     : ${props => props.$isFormType ? "0" : "1rem"};
  height            : ${props => props.$isFormType ? "2rem" : "auto"};
  min-height        : ${props => props.$isFormType ? "2rem" : "28px"};

`

/* --------------- PADER --------------------------- */

const Pader = styled.div<{$padding: string}>`
  width: 100%;
  padding: ${
    props =>  props.$padding 
                ? props.$padding
                : "0"
  };
`

/* --------------- SPACER --------------------------- */

const Spacer = styled.div<{height: string}>`
  width: 100%;
  height: ${
    props =>  props.height 
                ? props.height + "px" 
                : "10px"
  };
`

const SpacerRem = styled.div<{height: string}>`
  width: 100%;
  height: ${
    props =>  props.height 
                ? props.height + "rem" 
                : "1rem"
  };
`

/* --------------- VERTICAL SEPARATOR --------------- */
const VerticalSeparator = styled.div<{
  $height   : number,
  $margin?  : number
}>`
  width             : 1px;
  height            : ${props => props.$height}px;
  background-color  : #78829D33;
  margin            : 0 ${props => props.$margin ? props.$margin : "30"}px;
`

/* --------------- SUB PAGE SEPARATOR --------------- */

const SubPageSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #505A7D4D;
`

/* --------------- SPIN ----------------------------- */

const SpinWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100%;
  height: max-content;
`

const BigSpinner = styled.div`

  .itd-spin {
    width: 100%;
  }

  .itd-spin-spinner {
      
    width: 32px;
    height: 32px;
    //margin-top: -16px;
    //margin-left: -16px;

    >div>div {
      border-color: #cccccc transparent transparent;
    }

  }
  

`

/* --------------- DEFAULT HEIGHT ------------------- */

const DefaultHeight = styled.div<{
  $minHeight? : string | number,
  $align?     : string
}>`
  position        : relative;
  width           : 100%;
  display         : flex;
  justify-content : center;
  align-items     : ${props => props.$align ? props.$align : "center"};
  min-height      : ${
    props =>  props.$minHeight 
                ? typeof props.$minHeight === "string" ? props.$minHeight : props.$minHeight + "px"
                : "300px"
  };
  >div, >section {
    width: 100%;
  }
`

const LoadingDefaultHeight = styled(DefaultHeight)`
  position        : relative;
  width           : 100%;
  display         : flex;
  justify-content : center;
  align-items     : center;
`

const Loading = styled.div`

`

/* --------------- COLUMN --------------------------- */

const Col = styled.div<{col: string}>`
  grid-column: ${props => `span ${props.col}/auto`};
  width: 100%;
  `

/* --------------- GLOBAL CONTENT --------------------------- */

const ContentWrapper = styled.div`

  opacity: 0;
  transition: opacity .5s ease-out .05s;

  display: grid;
  grid-auto-rows: min-content;
  //grid-gap: 20px;

  min-height: 500px;

`

const EmptyContentWrapper = styled.div`

  height: 800px;
  min-height: 800px;

`

const ContentBody = styled.div`
  
  max-width: ${props => props.theme.content__width};
  width: 100%;
  
  margin: 0 auto;
  gap: 30px;

  display: flex;
  align-items: center;
  flex-direction: column;

  table, .p-2 {
    width: 100%;
  }

`

const NotFound = styled.div<{
  $fill?              : boolean,
  $minHeight?         : number | string,
  $textAreaMinHeight? : number | string,
  $textAreaPadding?   : string,
  $verticalAlign?     : string
}>`

  width             : 100%;
  min-height        : ${props => props.$minHeight ? AddDefaultUnit(props.$minHeight) : "500px"};

  display           : flex;
  align-items       : ${props => props.$verticalAlign ? props.$verticalAlign : "center"};
  justify-content   : center;
  
  div {
    
    width             : 100%;
    max-width         : ${props => props.$fill ? "inherit" : "400px"};
    min-height        : ${props => props.$fill ? "inherit" : (props.$textAreaMinHeight ? AddDefaultUnit(props.$textAreaMinHeight) : "100px")};;
    text-align        : center;

    display           : flex;
    align-items       : center;
    justify-content   : center;
    flex-direction    : column;
    gap               : 1rem;
    
    background-color  : ${props => props.theme.not__found.background.color};
    border-radius     : ${props => props.theme.border__radius};
    padding           : ${props => props.$textAreaPadding ? props.$textAreaPadding : "1.25rem 0.625rem"};

  }

  span {
    color             : ${props => props.theme.not__found.text.color};
    font-size         : 0.8125rem;
    font-weight       : 500;
  }

`

const FilledBox = styled.section<{
  $noPadding? : boolean
}>`

  width         : 100%;
  background    : #101c33;
  padding       : 1.5rem;
  border-radius : .5rem;

  button.itd-button.itd-button-filled {
    &:hover {
      background-color: #1d2c45;
    }
  }

  table.itd-table.itd-table-md thead tr {
    height: 3.5rem;
  }

  tbody tr td:first-child {
    padding-left: 1.5rem!important;
  }

  tbody tr td:last-child {
    padding-right: 1.5rem!important;
  }

  tbody tr:last-child {
    border-bottom: none!important;
  }

  thead tr th:first-child {
    padding-left: 1.5rem!important;
  }

  thead tr th:last-child {
    padding-right: 1.5rem!important;
  }

  @media screen and (max-width: 900px) {

    padding: .75rem;

    tbody tr td:first-child {
      padding-left: .75rem!important;
    }

    tbody tr td:last-child {
      padding-right: .75rem!important;
    }

    thead tr th:first-child {
      padding-left: .75rem!important;
    }

    thead tr th:last-child {
      padding-right: .75rem!important;
    }

  }

  ${props => props.$noPadding && css`
    padding: 0!important;
  `}

`

export { 
  Col, 
  SubPageHeader, 
  SpinWrapper, 
  Pader, 
  Spacer,
  SpacerRem, 
  SubPageSeparator,
  VerticalSeparator, 
  DefaultHeight, 
  BigSpinner,
  LoadingDefaultHeight, 
  ContentWrapper,
  ContentBody,
  Loading,
  NotFound,
  EmptyContentWrapper,
  FilledBox
};